import { useMemo } from 'react'

import { findPattern } from '../helpers/showcase'
import { useUAInsightsShowcase } from './useUAInsightsShowcase'

export interface ShowcasePatternArgs {
  /** Story pattern or sub-pattern id. */
  patternId: string
  /** Active motivation lens (motivation id), if any. */
  lensMotivationId?: string | null
  /** Scope stats/creatives to a single game. */
  gameId?: string | null
}

/**
 * A story pattern's lens-aware stats for the detail view: the entry for
 * `patternId` in the showcase `narrativePatterns`, loaded with the lens and
 * game scope applied. `parent` is set when the pattern is a sub-pattern.
 */
export const useShowcasePatternDetail = ({ patternId, lensMotivationId, gameId }: ShowcasePatternArgs) => {
  const { data, isLoading, isError, refetch } = useUAInsightsShowcase({ lensMotivationId, gameId })
  const detail = useMemo(() => {
    if (!data) return undefined
    const { pattern, parent } = findPattern(data.narrativePatterns, patternId)
    return pattern ? { pattern, parent, lensApplied: data.lensApplied, showcase: data } : null
  }, [data, patternId])
  return { data: detail, isLoading, isError, refetch }
}
